// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubHeader_wrapper__1GOo-","content":"SubHeader_content__1bsqM","btnBack":"SubHeader_btnBack__1fbQx","line":"SubHeader_line__30LTs"};